// Показать еще
var indexReviews = 0;
$('#showmorereviews').click(function () {
    var limitReviews = $('#showmorereviews').attr('data-limit-reviews');
    var offsetReviews = $('#showmorereviews').attr('data-offset-reviews');
    indexReviews++;
    $.ajax({
        method: "POST",
        url: '/reviews',
        data: {
            index: indexReviews,
            limitReviews: limitReviews,
            offsetReviews: offsetReviews,
        },
        success: function (msg) {
            $('.reviews-new').append(msg[0]);
            if (msg[1]) {
                $('#showmorereviews').detach();
            }
        },
        dataType: "json"
    });
});

// Спойлер отзывы
if (document.getElementsByClassName('reviews').length) {
    document.getElementsByClassName('reviews')[0].onclick = function (e) {
        if (e.target.classList.contains('btn-open')) {
            var prev = e.target.previousElementSibling.classList;
            if (prev.contains('open')) {
                prev.remove('open');
                e.target.textContent = 'Читать полностью';
            } else {
                prev.add('open');
                e.target.textContent = 'Свернуть отзыв';
            }
        }
    };
}
